import React from 'react';
import { Configurations } from '../../Utils/Configurations';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import InputMask from 'react-input-mask';
import './Modal-Beneficiarios.scss';
import SearchMemberTypeAhead from '../Search-Member-Type-Ahead/Search-Member-Type-Ahead';


class ModalBeneficiarios extends React.Component {

    constructor(props) {
        super(props);
        this.Configurations = new Configurations();

        this.botaoAlterar = this.botaoAlterar.bind(this);
        this.handleAlterarBeneficiario = this.handleAlterarBeneficiario.bind(this);
        this.botaoSalvar = this.botaoSalvar.bind(this);
        this.handleAdicionarBeneficiario = this.handleAdicionarBeneficiario.bind(this);
        this.botaoAdicionar = this.botaoAdicionar.bind(this);
        this.getMembroSelecionado = this.getMembroSelecionado.bind(this);


        this.initialState = {
            novoNome: '',
            novoEmail: '',
            novoCelular: '',
            nomeBeneficiarioAdicionado: '',
            emailBeneficiarioAdicionado: '',
            celularBeneficiarioAdicionado: '',
            flagAlterarNomeColuna: false
        }

        this.state = this.initialState;
    }

    componentDidUpdate(prevProps) {
        if ((this.props.listaBeneficiario !== prevProps.listaBeneficiario)
            || ((this.props.isOpen !== prevProps.isOpen) && !this.props.isOpen)) {
            this.setState(this.initialState);
        }
    }

    botaoAlterar(index) {
        this.props.setIndexEdicao(index);
        this.setState({
            novoNome: this.props.listaBeneficiario[index].nomePresenteado,
            novoEmail: this.props.listaBeneficiario[index].emailPresenteado,
            novoCelular: this.props.listaBeneficiario[index].celularPresenteado,
            nomeBusca: undefined,
            idUsuarioBusca: undefined,
            flagAlterarNomeColuna: true
        })

    }

    handleAlterarBeneficiario(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }

    botaoSalvar(id) {
        const _index = this.props.listaBeneficiario.findIndex(item => item.idItemBeneficiario === id)
        const alteracoesBeneficiario = {
            nomePresenteado: this.state.nomeBusca || this.props.listaBeneficiario[_index].nomePresenteado,
            emailPresenteado: this.state.novoEmail,
            celularPresenteado: this.state.novoCelular,
            idUsuarioPresenteado: this.state.idUsuarioBusca || this.props.listaBeneficiario[_index].idUsuarioConfirmado
        }
        this.props.botaoSalvarAlteracoesBeneficiario(id, alteracoesBeneficiario);
    }

    handleAdicionarBeneficiario(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }

    botaoAdicionar() {
        const beneficiarioAdicionado = {
            nomePresenteado: this.state.nomeBeneficiarioAdicionado,
            emailPresenteado: this.state.emailBeneficiarioAdicionado,
            celularPresenteado: this.state.celularBeneficiarioAdicionado
        }

        this.props.adicionarBeneficiario(beneficiarioAdicionado)
    }

    getMembroSelecionado(membro) {
        if (membro && !!membro.idUsuario) {
            this.setState({
                nomeBusca: membro.nome,
                idUsuarioBusca: membro.idUsuario
            })
        }
    }

    render() {
        const {
            isOpen,
            toggle,
            listaBeneficiario,
            flagBeneficiarioAceite,
            enviarMensagem,
            isLoadingMensagem,
            isLoadingAlteracoesBeneficiario,
            indexEdicao,
            qtdBeneficiarios,
            isLoadingAdicionarBeneficiario,
        } = this.props;

        return (
            <Modal className="modal-beneficiarios" size="lg" isOpen={isOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}> Beneficiários </ModalHeader>
                <ModalBody>
                    <div className='col-12'>
                        {this.state.flagAlterarNomeColuna && (
                            <React.Fragment>
                                <p className='m-0'><small><strong>Opções de busca:</strong></small></p>
                                <p className='m-0'><small>- Nome</small></p>
                                <p className='m-0'><small>- Cód. de membro("m") - Ex: m4567</small></p>
                                <p className='m-0 pb-3'><small>- CPF("c") - Ex: c12345678900</small></p>
                            </React.Fragment>
                        )}
                        <table className="tabela-beneficiarios table w-100 text-center table-bordered">
                            <thead>
                                <tr>
                                    {this.state.flagAlterarNomeColuna ? <th width={flagBeneficiarioAceite ? "10%" : "25%"}><p className='m-0'>Busca</p>
                                    </th> : <th width={flagBeneficiarioAceite ? "10%" : "25%"}><p className='m-0'>Cód. membro</p></th>}
                                    <th width={flagBeneficiarioAceite ? "20%" : "25%"}>Nome</th>
                                    <th width={flagBeneficiarioAceite ? "20%" : "25%"}>Email</th>
                                    <th width={flagBeneficiarioAceite ? "15%" : "25%"}>Celular</th>
                                    {flagBeneficiarioAceite && (
                                        <React.Fragment>
                                            <th width="5%">Mensagem</th>
                                            <th width="5%">Alterar</th>
                                        </React.Fragment>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {listaBeneficiario.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            {indexEdicao === index ? (
                                                <td width="10%" className='text-center typeahead-beneficiario'>
                                                    <SearchMemberTypeAhead
                                                        beneficiarios={true}
                                                        getMembroSelecionado={this.getMembroSelecionado}
                                                        disableInput={false}
                                                    />
                                                </td>
                                            ) : (
                                                <td>
                                                    {item.flagAssinaturaAceita ? (
                                                        <React.Fragment>
                                                            {item.codMembro ? (
                                                                <React.Fragment>
                                                                    {item.codMembro}
                                                                </React.Fragment>
                                                            ) : (
                                                                <React.Fragment>
                                                                    <span className='badge badge-warning text-dark'>Não é membro</span>
                                                                </React.Fragment>
                                                            )}
                                                        </React.Fragment>
                                                    ) : (
                                                        <span className='badge badge-danger'>Não identificado</span>
                                                    )}
                                                </td>
                                            )}
                                            <td width="20%" className='text-center'>
                                                {indexEdicao === index ? (
                                                    <React.Fragment>
                                                        {!!this.state.nomeBusca ? (
                                                            <span className='badge badge-warning text-dark'>{this.state.nomeBusca}</span>
                                                        ) : (
                                                            <React.Fragment>
                                                                {item.nomePresenteado}
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        {item.nomePresenteado}
                                                    </React.Fragment>
                                                )}
                                            </td>
                                            <td width="20%" className='text-center'>
                                                {indexEdicao === index ? (
                                                    <input name="novoEmail" type="email" className="form-control" value={this.state.novoEmail} onChange={this.handleAlterarBeneficiario} autoComplete="disabled" />
                                                ) : (
                                                    <React.Fragment>
                                                        {item.emailPresenteado}
                                                    </React.Fragment>
                                                )}
                                            </td>
                                            <td width="15%" className='text-center'>
                                                {indexEdicao === index ? (
                                                    <InputMask
                                                        type="tel"
                                                        className="form-control"
                                                        maskChar=""
                                                        mask="(99)99999-9999"
                                                        id="novoCelular"
                                                        name="novoCelular"
                                                        value={this.state.novoCelular}
                                                        onChange={this.handleAlterarBeneficiario}
                                                        autoComplete="disabled"
                                                    />
                                                ) : (
                                                    <React.Fragment>
                                                        {item.celularPresenteado}
                                                    </React.Fragment>
                                                )}
                                            </td>
                                            {flagBeneficiarioAceite && (
                                                <td width="5%">
                                                    <React.Fragment>
                                                        {isLoadingMensagem === item.idItemBeneficiario ? (
                                                            <div style={{width: '20px', height: '20px'}} className="spinner-border text-primary text-center" role="status" />
                                                        ) : (
                                                            <button className="btn btn-sm btn-outline-success" onClick={() => enviarMensagem(item.idItemBeneficiario)} disabled={indexEdicao === index}>Enviar</button>
                                                        )}
                                                    </React.Fragment>
                                                </td>
                                            )}

                                            {flagBeneficiarioAceite && (
                                                <td width="5%">
                                                    {indexEdicao === index ? (
                                                        <React.Fragment>
                                                            {isLoadingAlteracoesBeneficiario ? (
                                                                <div className="spinner-border  text-primary" role="status" />
                                                            ) : (
                                                                <button className="btn btn-sm btn-outline-success" onClick={() => this.botaoSalvar(item.idItemBeneficiario)}>Salvar</button>
                                                            )}
                                                        </React.Fragment>
                                                    ) : (
                                                        <button className="btn btn-sm btn-outline-primary" onClick={() => this.botaoAlterar(index)}>Alterar</button>
                                                    )}
                                                </td>
                                            )}
                                        </tr>
                                    )
                                })
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='col-12'>
                        {qtdBeneficiarios > 0 && (
                            <div className='row no-gutters py-2'>
                                <div className='col-12 text-center text-info py-3'>
                                    <h5>Há {qtdBeneficiarios} {qtdBeneficiarios > 1 ? "beneficiários" : "beneficiário"} a adicionar</h5>
                                </div>
                                <div className="col-5 px-1">
                                    <label>Nome</label>
                                    <input type="text" name="nomeBeneficiarioAdicionado" className="form-control" value={this.state.nomeBeneficiarioAdicionado} onChange={this.handleAdicionarBeneficiario} placeholder='Nome completo do beneficiário' autoComplete="disabled" />
                                </div>
                                <div className="col-3 px-1">
                                    <label>E-mail</label>
                                    <input type="email" name="emailBeneficiarioAdicionado" className="form-control" value={this.state.emailBeneficiarioAdicionado} onChange={this.handleAdicionarBeneficiario} placeholder='usuario@dominio.com.br' autoComplete="disabled" />
                                </div>
                                <div className="col-2 px-1">
                                    <label>Celular</label>
                                    <InputMask
                                        type="tel"
                                        className="form-control"
                                        maskChar=""
                                        mask="(99)99999-9999"
                                        id="celularBeneficiarioAdicionado"
                                        name="celularBeneficiarioAdicionado"
                                        placeholder="(99)99999-9999"
                                        value={this.state.celularBeneficiarioAdicionado}
                                        onChange={this.handleAdicionarBeneficiario}
                                        autoComplete="disabled"
                                    />
                                </div>
                                <div className='col-2 px-2 text-center align-items-end d-flex'>
                                    {isLoadingAdicionarBeneficiario ? (
                                        <div className="spinner-border  text-primary text-center" role="status" />
                                    ) : (
                                        <button className='btn btn-outline-success' onClick={this.botaoAdicionar}>Adicionar</button>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </ModalBody>
            </Modal >
        );
    }


}

export default ModalBeneficiarios